import type { Components, Theme } from '@mui/material/styles';

import { createTransition } from 'utils/transitions';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: { underline: 'hover' },
  styleOverrides: {
    root: ({ theme }) => ({
      '--Link-hover-underlineColor': 'var(--mui-palette-primary-main)',
      '--Link-hover-transform': 'scaleX(0)',

      cursor: 'pointer',
      position: 'relative',
      display: 'inline-flex',

      transition: createTransition(theme),

      '&:hover': {
        textDecoration: 'none',
        transition: createTransition(theme),
      },

      '&:before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        width: '100%',
        height: '1px',
        bottom: '0px',
        left: '0px',
        backgroundColor: 'var(--Link-hover-underlineColor)',
        transform: 'var(--Link-hover-transform)',
        transformOrigin: 'top left',
        transition: createTransition(theme),
      },

      '&:hover:before': {
        transform: 'scaleX(1)',
      },
    }),
  },
};
